import { FC } from 'react';
import ServiceDetail from './ServiceDetail';
import UseServiceDetail from './UseServiceDetail';

const ServiceDetailContainer: FC = () => {
  return <ServiceDetail {...UseServiceDetail()} />;
};

export default ServiceDetailContainer;
